import styled from '@emotion/styled';
import { CheckCircle, XCircle, Info, Clock } from 'lucide-react';
import type { Order } from '@/domain/entities/order.entity';
import { getStatusBadgeInfo } from './utils';
import { BADGE_COLORS, type BadgeVariant } from './constants';

const Badge = styled.span<{ variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 100px;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  background: ${({ variant }) => BADGE_COLORS[variant].bg};
  color: ${({ variant }) => BADGE_COLORS[variant].fg};
  white-space: nowrap;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;

const ICON_MAP = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: Clock,
} as const;

interface OrderStatusBadgeProps {
  readonly order: Order;
}

export function OrderStatusBadge({ order }: Readonly<OrderStatusBadgeProps>) {
  const { label, variant } = getStatusBadgeInfo(order);
  const Icon = ICON_MAP[variant];

  return (
    <Badge variant={variant}>
      <Icon size={14} />
      {label}
    </Badge>
  );
}
